import { render } from "./ReportDocX.vue?vue&type=template&id=1d11839c&scoped=true"
import script from "./ReportDocX.vue?vue&type=script&lang=js"
export * from "./ReportDocX.vue?vue&type=script&lang=js"

import "./ReportDocX.vue?vue&type=style&index=0&id=1d11839c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d11839c"]])

export default __exports__